export enum EventTypes {
  SET_PATH = 'setPath',
  IDENTIFY = 'identify'
}
